
<template>
  <div class="award-container">
    <div v-if="isHasReward" class="coupon-container">
      <soda-coupon-cell
        class="coupon-cell"
        :couponSrc="couponData"
        :country="getCountry"
        :isOldCustomer="true"
        :isCompleteMission="isCompleteMission"
        @handleUse="handleUse"
      />
    </div>
    <div v-else class="no-award-box">
        <img class="no-award-icon" src="../../../../assets/images/oldCustomer/no_result.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: 'AwardCoupon',
  props: {
    isHasReward: {
      default: false
    },
    isCompleteMission: {
      default: false
    },
    couponData: {
      default: () => {}
    }
  },
  computed: {
    // 获取对应的国家
    getCountry () {
      return this.$store.state.country
    }
  },
  methods: {
    handleUse (coupon) {
      this.$emit('handleUse', coupon, 'couponButton')
    }
  }
}
</script>
<style lang="stylus" scoped>
.award-container
    background #F8F8F8
    padding-bottom 48px
.coupon-container
    margin 0 auto
    width 638px
    min-height 204px
    box-shadow 0px 20px 48px 0px rgba(0,0,0,0.08) 
    overflow hidden
    border-radius 12px
    .coupon-cell  
        width 100% 
.no-award-box
    display flex
    justify-content center
.no-award-icon
    width 288px
    height 288px
.coupon-ui-bg-img
    background-color #ececec !important

.coupon-cell
  >>> .coupon-logo 
    margin-bottom 0 !important
    img 
      width 96px !important
      height 96px !important
      margin 54px 20px 54px 0 !important
    >div
      .title
        line-height 36px !important
      .time
        font-size 22px
        line-height 24px
        font-family 'Aspira Light'
        font-weight 200
        white-space normal !important
  >>> .coupon-dl
    dt
      padding 0 32px !important
      display: flex
      align-items: center
    dd
      padding 15px 0 !important
      .use-threshold 
        padding 0 8px !important
      .discount
        font-weight 500 !important
        margin 0 auto !important
        white-space normal !important 
        word-break: break-all
        height: auto !important  
      .use-btn
        margin 14px auto 0 auto !important
        height 60px !important
        line-height: 60px;
        display inline-block;
        box-sizing border-box
        span 
          height 60px !important
          max-width 190px !important
          min-width auto !important
          padding 0 24px !important
          box-sizing border-box !important
>>> .coupon-ui .coupon-content dl dd .use-threshold 
  white-space normal !important 
  word-break: break-all  

</style>